import React, { useState, useEffect } from 'react';
import './popup.css';

const Popup = () => {
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const popupShown = localStorage.getItem('popupShown');
    if (!popupShown) {
      setShowPopup(true);
      localStorage.setItem('popupShown', 'true');
    }
  }, []);

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button 
          className="close-button" 
          onClick={() => setShowPopup(false)}
        >
          ×
        </button>

        <img 
          src="/programcoordinator1.png" 
          alt="Advertisement" 
          className="advertisement-image"
        />
      </div>
    </div>
  );
};

export default Popup;